import { FETCH_RECOS, RECEIVE_RECOS } from 'constants/reduxActions';
import { normalizeToPatronLikeProduct } from 'helpers/RecoUtils';

const DEFAULT_RECO_TITLE = 'Recommendations For You';
function extractDataFromWidget(widget, imageHost) {
  return {
    title: widget.title || DEFAULT_RECO_TITLE,
    recos: (widget.sims || widget.recs || []).map(reco => {
      const { recoName } = widget;
      const normalized = normalizeToPatronLikeProduct(reco, imageHost, recoName);
      return { ...normalized, recoName };
    })
  };
}

export default function recos(state = { }, action) {
  const { type, key, data, imageHost } = action;

  switch (type) {
    case FETCH_RECOS:
      return { ...state, isLoading: true };
    case RECEIVE_RECOS:
      const keys = Object.keys(data);
      // if one widget was requested put the info in the top level for ease of use.
      const newEntry = {};
      if (keys.length === 1) {
        newEntry[key] = extractDataFromWidget(data[keys[0]], imageHost);
      } else {
        // otherwise nest key = { widgetId: { title, recos } }
        const newData = {};
        keys.forEach(prop => {
          newData[prop] = extractDataFromWidget(data[prop], imageHost);
        });
        newEntry[key] = newData;
      }

      const filteredRecos = state.janus || {};
      const newRecoContents = { ...filteredRecos, ...newEntry };
      return { ...state, isLoading: false, janus: { ...newRecoContents }, lastReceivedRecoKey: key };
    default:
      return state;
  }
}
